import { Grid, Skeleton } from '@mui/material';

export const WalletPaymentRequestFormSkeleton = () => {
    return (
        <>
            <Skeleton width={200} height={40} />
            <Grid container spacing={2}>
                <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                    <Skeleton height={90} />
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                    <Skeleton height={90} />
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                    <Skeleton height={90} />
                </Grid>
            </Grid>
            <Skeleton width={240} height={40} />
            <Skeleton height={55} />
            <Grid container spacing={2}>
                <Grid size={{ xs: 12, sm: 5, md: 2.7 }}>
                    <Skeleton height={70} />
                </Grid>
                <Grid size={{ xs: 12, sm: 3, md: 2 }}>
                    <Skeleton height={70} />
                </Grid>
            </Grid>
        </>
    );
};
